import {MultiSelect} from '@blueprintjs/select';
import React, {Component} from 'react';
import {Classes, Intent, Tooltip, Callout, MenuItem, Tag} from '@blueprintjs/core';
import SmsCounter from 'sms-counter';
import toastr from 'toastr';
import {getJwt} from '../../services/authService';
import http from '../../services/httpService';
import InfoCircle from '../common/InfoCircle';
import Input from '../common/Input';
import InputRegular from '../common/InputRegular';
import TagsMultiselector from '../common/TagsMultiselector';
import TextArea from '../common/TextArea';


class SingleTrigger extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editActive: false,
            spinnerActive: false,
            fieldsCheckActive: '',
            errorsList: [],
            name: this.props.name,
            keywords: this.props.keywords && this.props.keywords.length ? this.props.keywords.join(', ') : '',
            actions: this.props.actions && this.props.actions.length ? this.props.actions :
                [{
                    type: 'sms',
                    value: '',
                    characterCount: 0,
                    messagesCount: 1,
                    charsRemaining: 160,
                    charsPerMessage: 160,
                }],
            initialHandleTagsToFullTags: false,
            initialHandleRemoveTagsToFullTags: false,
            defaultResponseActive: (this.props.type === 'response-inactive') || (this.props.type === 'response-active') ? this.props.type : '',
            exceedingError: false
        }
    }


    componentDidMount() {
        // console.log('single trigger props: ', this.props)
        // if(this.state.defaultResponseActive){ console.log('actions: ', this.state.actions)}
        this.state.actions.map((action, index) => ((action.type === 'tags') || (action.type === 'remove_tags')) && action.value && action.value.length && (!action.selectedTags || !action.selectedTags.length) ?
            action.type === 'tags' ?
                this.handleTagsToFullTags(action.value, index)
                :
                action.type === 'remove_tags' ?
                    this.handleRemoveTagsToFullTags(action.value, index)
                    :
                    ''
            :
            ''
        )
    }

    componentDidUpdate = () => {
        // console.log('check tags to fullTags: ', this.state.actions)
        // if(this.state.defaultResponseActive){ console.log('actions: ', this.state.actions)}
        if (!this.state.initialHandleTagsToFullTags) {
            this.state.actions.map((action, index) => ((action.type === 'tags') || (action.type === 'remove_tags')) && action.value && action.value.length && (!action.selectedTags || !action.selectedTags.length) ?
                action.type === 'tags' ?
                    this.handleTagsToFullTags(action.value, index)
                    :
                    action.type === 'remove_tags' ?
                        this.handleRemoveTagsToFullTags(action.value, index)
                        :
                        ''
                :
                ''
            )
        }
        // if(this.props.name === 'Stop'){ console.log('this.state.actions: ', this.state.actions)}
    }

    handleTagsToFullTags = (tags, index) => {
        if (this.props.tags && this.props.tags.length) {
            if (!this.state.initialHandleTagsToFullTags) {
                this.setState({initialHandleTagsToFullTags: true})
            }
            let loadedActions = this.props.actions;
            let fullTags = [];
            let fullActions = this.state.actions;
            // console.log('handleRemoveTagsToFullTags: ', tags, index, this.props.tags)
            fullTags = this.props.tags.filter(tag => tags && tags.length ? tags.find(actionTag => actionTag === tag.tag) : '')
            fullActions[index].selectedTags = fullTags;


            this.setState({actions: fullActions})
            // console.log('handleTagsToFullTags: ', this.props.tags, tags, index, fullTags, fullActions, this.state.actions)
        }

        // loadedActions.map(action => action.tags && action.tags.length ? fullTags = this.props.tags.filter(tag=> action.tags.find(actionTag=>actionTag === tag.tag )) : '')
    }

    handleRemoveTagsToFullTags = (tags, index) => {
        if (this.props.tags && this.props.tags.length) {
            if (!this.state.initialHandleRemoveTagsToFullTags) {
                this.setState({initialHandleRemoveTagsToFullTags: true})
            }
            let loadedActions = this.props.actions;
            let fullTags = [];
            let fullActions = this.state.actions;
            // console.log('handleRemoveTagsToFullTags: ', tags, index, this.props.tags)
            fullTags = this.props.tags.filter(tag => tags && tags.length ? tags.find(actionTag => actionTag === tag.tag) : '')
            fullActions[index].selectedTags = fullTags;


            this.setState({actions: fullActions})
            // console.log('handleTagsToFullTags: ', this.props.tags, tags, index, fullTags, fullActions, this.state.actions)
        }

        // loadedActions.map(action => action.tags && action.tags.length ? fullTags = this.props.tags.filter(tag=> action.tags.find(actionTag=>actionTag === tag.tag )) : '')
    }

    handleEdit = () => {
        this.state.editActive ?
            this.setState({
                editActive: false,
            })
            :
            this.setState({
                editActive: true,
                // keywords: this.props.keywords && this.props.keywords.length ? this.props.keywords.join(', ') : '',
                // message: this.props.message,
                // actions: this.props.actions
            })
    }

    handleAddAction = () => {
        // if((this.state.actions && !this.state.actions.length) || !this.state.replyWithSmsAdded){
        //     this.setState({
        //         actions: [
        //             ...this.state.actions,
        //             {
        //                 selected: 'Reply with SMS',
        //                 sms: ''
        //             }
        //         ],
        //         replyWithSmsAdded: true,
        //     })
        // }else if(this.state.replyWithSmsAdded && !this.state.assignTagAdded){
        //     this.setState({
        //         actions: [
        //             ...this.state.actions,
        //             {
        //                 selected: 'Assign Tag',
        //                 tags: []
        //             }
        //         ],
        //         assignTagAdded: true
        //     })
        // }else if(this.state.replyWithSmsAdded && this.state.assignTagAdded){
        //     this.setState({
        //         actions: [
        //             ...this.state.actions,
        //             {
        //                 selected: 'Webhook URL',
        //                 url: ''
        //             }
        //         ],
        //         notifyWebhookAdded: true,
        //     })
        // }
        this.setState({
            actions: [
                ...this.state.actions,
                {
                    type: 'sms',
                    value: '',
                    characterCount: 0,
                    messagesCount: 1,
                    charsRemaining: 160,
                    charsPerMessage: 160,
                }
            ],
            // replyWithSmsAdded: true,
        })
    }

    handleChangeAction = (selectedAction, actionIndex) => {
        let actions = this.state.actions;
        let actionBeforeChange = actions[actionIndex];

        if (selectedAction === 'sms') {

            actions[actionIndex] = {
                type: 'sms',
                value: '',
                characterCount: 0,
                messagesCount: 1,
                charsRemaining: 160,
                charsPerMessage: 160,
            }

            this.setState({
                actions,
                // replyWithSmsAdded: true,
            })
        } else if (selectedAction === 'tags') {
            actions[actionIndex] = {
                type: 'tags',
                value: [],
                selectedTags: [],
                selectedTagsIds: []
            }

            this.setState({
                actions,
                // assignTagAdded: true,
            })
        } else if (selectedAction === 'remove_tags') {
            actions[actionIndex] = {
                type: 'remove_tags',
                value: [],
                selectedTags: [],
                selectedTagsIds: []
            }

            this.setState({
                actions,
                // assignTagAdded: true,
            })
        } else if (selectedAction === 'webhook') {
            actions[actionIndex] = {
                type: 'webhook',
                value: ''
            }

            this.setState({
                actions,
                // notifyWebhookAdded: true,
            })
        } else if (selectedAction === 'subscription') {
            actions[actionIndex] = {
                type: 'subscription',
                value: 1
            }

            this.setState({
                actions,
                // notifyWebhookAdded: true,
            })
        }

        // if(actionBeforeChange.selected === 'Reply with SMS'){
        //     this.setState({replyWithSmsAdded: false})
        // }else if(actionBeforeChange.selected === 'Assign Tag'){
        //     this.setState({assignTagAdded: false})
        // }else if(actionBeforeChange.selected === 'Webhook URL'){
        //     this.setState({notifyWebhookAdded: false})
        // }
    }

    handleRemoveAction = (index) => {
        let array = [...this.state.actions]; // make a separate copy of the array
        array.splice(index, 1);
        this.setState({actions: array});
    }

    handleRemoveTrigger = async () => {
        let userId = this.props.user.id;
        let selectedSource = this.props.selectedSource;
        try {
            //  console.log(data.tagId)
            //     console.log('net tag name:', data.new_tag)
            let deleteTrigger = await http.delete('api/user/' + userId + '/project/' + selectedSource + '/workspace_triggers',
                {
                    headers: {authorization: getJwt()},
                    data: {"batch_time": this.props.batchTime},
                },
            );
            this.props.handleGetTriggers();
        } catch (ex) {
            if (ex.response && ex.response.status === 404)
                toastr.error("Something went wrong... Please refresh and try again.");
            if (ex.response && ex.response.status === 401) {
                toastr.error(ex.response.data.message);

            }
        }
    }

    handlePatchTrigger = async () => {
        let userId = this.props.user.id;
        let selectedSource = this.props.selectedSource;
        this.setState({spinnerActive: true, fieldsCheckActive: true})
        setTimeout(async () => {
            let anyErrorActive = false;
            await this.state.errorsList.map(error => error ? anyErrorActive = true : '')
            let checkTagsEmpty = false;
            this.state.actions.map(action => ((action.type === 'tags') || (action.type === 'remove_tags')) && action.value && !action.value.length ? checkTagsEmpty = true : '')
            if (!anyErrorActive && !checkTagsEmpty) {
                let preparedActions = [];
                await this.state.actions.map(action => preparedActions.push({
                    type: action.type,
                    value: action.value
                }))
                // this.props.handleSave({
                //     title: this.state.title,
                //     keywords: this.state.keywords.split(',').map(item => item.trim()).filter(x=>x),
                //     message: this.state.message,
                //     actions: this.state.actions
                // });
                try {
                    //  console.log(data.tagId)
                    //     console.log('net tag name:', data.new_tag)
                    let patchTrigger = await http.patch('api/user/' + userId + '/project/' + selectedSource + '/workspace_triggers', {
                        "name": this.state.name,
                        "type": this.state.defaultResponseActive || this.props.type,
                        "batch_time": this.props.batchTime,
                        "keywords": this.state.keywords.split(',').map(item => item.trim()).filter(x => x),
                        "actions": preparedActions
                    }, {headers: {authorization: getJwt()}});
                    this.props.handleGetTriggers();
                    this.toggleNewTrigger();
                    this.setState({spinnerActive: false})
                } catch (ex) {
                    this.setState({spinnerActive: false})
                    if (ex.response && ex.response.status === 404)
                        toastr.error("Something went wrong... Please refresh and try again.");
                    if (ex.response && ex.response.status === 401) {
                        toastr.error(ex.response.data.message);

                    }
                }
            } else {
                this.setState({spinnerActive: false})
            }
        }, 500)
    }

    handleActionUpdate = (type, index, value) => {
        // console.log('update')
        if (type === 'sms') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                value: value,
                characterCount: SmsCounter.count(value).length,
                messagesCount: SmsCounter.count(value).messages,
                charsRemaining: SmsCounter.count(value).remaining,
                charsPerMessage: SmsCounter.count(value).per_message,
            }
            this.setState({actions})
        } else if (type === 'tags') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                value: value,
                selectedTags: [],
                selectedTagsIds: []
            }
            this.setState({actions})
            this.handleTagsToFullTags(value, index)
        } else if (type === 'webhook') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                value: value
            }
            this.setState({actions})
        } else if (type === 'subscription') {
            let actions = this.state.actions;
            actions[index] = {
                ...actions[index],
                value: value
            }
            this.setState({actions})
        }
        //console.log('character count: ', SmsCounter.count(value).length)
        //console.log('document.querySelector(\'textarea .register-password\'): ', document.querySelector('textarea.register-password[placeholder="Enter message here"]'))
        if (SmsCounter.count(value).length > 320) {
            // console.log('length > 320')
            this.setState({
                exceedingError: true
            })
            document.querySelector('textarea.register-password[placeholder="Enter message here"]').classList.add('exceeding-error-textarea')
        } else {
            //console.log('length < 320')
            this.setState({
                exceedingError: false
            })
            document.querySelector('textarea.register-password[placeholder="Enter message here"]').classList.remove('exceeding-error-textarea')
        }
    }

    multiMenuItem = (item, tags, {modifiers, handleClick}) => {
        if (tags && tags.includes(item) === false) {
            return (
                <MenuItem
                    className='multiselect-menu-item'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    query=''
                    shouldDismissPopover={true}

                />

            )
        } else {
            return (
                <MenuItem
                    className='multiselect-menu-item'
                    icon='small-tick'
                    active={modifiers.active}
                    key={item.id}
                    label=''
                    text={item.tag}
                    onClick={handleClick}
                    shouldDismissPopover={true}
                />
            )
        }
    };

    updateTags = async (tags, index) => {
        let actions = [...this.state.actions]
        let selectedTagsIds = await [];
        let selectedTagsNames = await [];
        await tags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
            selectedTagsNames = [...selectedTagsNames, tag.tag]
        })
        actions[index] = {
            ...actions[index],
            selectedTags: tags,
            selectedTagsIds,
            value: selectedTagsNames
        }
        await this.setState({actions});
    }


    tagSelect = (item, index) => {
        let actions = [...this.state.actions]
        let selectedTagsIds = this.state.actions[index].selectedTagsIds;
        let selectedTagsNames = this.state.actions[index].value
        // console.log('tag select item:', item, actions, actions[index]);
        const selectedTags = this.state.actions[index].selectedTags || [];

        if (selectedTags.includes(item) === false) {
            selectedTagsIds.push(item.id)
            selectedTags.push(item);
            selectedTagsNames.push(item.tag)

            actions[index] = {
                ...actions[index],
                selectedTags,
                selectedTagsIds,
                value: selectedTagsNames
            }
            this.setState({actions});
            // console.log('Usao u prvi if');
        } else {
            const newTags = selectedTags.filter(t => t !== item);
            const newTagsIds = [];
            const newTagsNames = [];
            newTags.map(tag => {
                newTagsIds.push(tag.id)
                newTagsNames.push(tag.tag)
            })
            actions[index] = {
                ...actions[index],
                selectedTags: newTags,
                selectedTagsIds: newTagsIds,
                value: newTagsNames
            }
            this.setState({actions});
            // console.log('Usao u else');
        }

        // console.log('result of select tags:', selectedTagsIds, selectedTags, this.state.actions );
        // this.state.actions[index].value.map(tag => {
        //     selectedTagsIds = [...selectedTagsIds, tag.id]
        // });
        // console.log('tagSelect: ', selectedTags, actions, selectedTagsIds)
    };

    handleTagRemove = (item, index) => {
        let actions = [...this.state.actions]
        let selectedTagsIds = [];
        let selectedTagsNames = [];

        const selectedTags = this.state.actions[index].value;
        const fullTags = this.state.actions[index].selectedTags;
        // console.log('handleTagRemove: ', item, selectedTags, fullTags)
        const newTags = [];
        const newTagsNames = [];

        const newFullTags = fullTags.filter(t => t.tag !== item.props.children);
        newFullTags.map(tag => {
            newTags.push(tag.id)
            newTagsNames.push(tag.tag)
        })


        newTags.map(tag => {
            selectedTagsIds = [...selectedTagsIds, tag.id]
            selectedTagsNames = [...selectedTagsNames, tag.tag]
        });


        actions[index] = {
            ...actions[index],
            selectedTags: newFullTags,
            selectedTagsIds: newTags,
            value: newTagsNames
        }

        this.setState({actions});

    };

    tagRender = (item) => {


        // console.log('tag render item:', item);
        // console.log('')
        return (
            <Tag key={item.id}>{item.tag}</Tag>
        )
        // console.log('tag render end');
    };

    filterTags = (item) => {

        //console.log('filter item:', item);

        return this.props.tags.filter((t) => {
            return t.tag.toLowerCase().includes(item.toLowerCase());
        });
    };

    updateErrorsList = (error, id) => {
        let errorsList = this.state.errorsList;
        errorsList[parseInt(id) - 1] = error;
        this.setState({errorsList})
    }

    render() {

        return (
            this.state.editActive ?
                <div className="single-trigger-container active">
                    {this.props.customTrigger ?
                        <div className="space-between margin-bottom-10 ">
                            <div className="single-trigger-title">

                                <h3>{this.props.name === 'Start' ? 'Subscribe' : this.props.name === 'Stop' ? 'Unsubscribe' : this.props.name}</h3>
                                {this.props.infoDescription ?

                                    <InfoCircle
                                        icon='question'
                                        infoCircleContent={
                                            <p className='info-circle-content'>
                                                {this.props.infoDescription}
                                            </p>
                                        }
                                    /> : ''
                                }
                            </div>
                            <a className='text-red' onClick={this.handleRemoveTrigger}>Delete</a>
                        </div>
                        :
                        <div className="space-between margin-bottom-10 ">
                            <div className="single-trigger-title">
                                <h3>{this.props.name === 'Start' ? 'Subscribe' : this.props.name === 'Stop' ? 'Unsubscribe' : this.props.name} </h3>
                                {this.props.infoDescription ?

                                    <InfoCircle
                                        icon='question'
                                        infoCircleContent={
                                            <p className='info-circle-content'>
                                                {this.props.infoDescription}
                                            </p>
                                        }
                                    /> : ''
                                }
                            </div>
                            {this.props.name === 'Default Response' ?
                                this.state.defaultResponseActive === 'response-active' ?
                                    <a className='text-red'
                                       onClick={() => this.setState({defaultResponseActive: 'response-inactive'})}>Disable</a>
                                    :
                                    <a onClick={() => this.setState({defaultResponseActive: 'response-active'})}>Activate</a>
                                :
                                ''
                            }
                        </div>
                    }

                    {/*<h3>{this.props.title}</h3>*/}
                    <p>{this.props.description}</p>
                    {this.props.reservedKeywords && this.props.reservedKeywords.length ?
                        <div className="triggers-container">
                            <p className="keywords-label margin-bottom-20 margin-top-20">Reserved
                                keywords: {this.props.reservedKeywords.map((trigger, key) => <span className='tag'
                                                                                                   key={key}>{trigger}</span>)}</p>
                        </div>
                        :
                        ''
                    }
                    {this.state.defaultResponseActive ?
                        ''
                        :
                        <div className="new-trigger-bottom-border">
                            <InputRegular
                                id="2"
                                label1="Keywords"
                                label2=""
                                placeholder="Enter keywords"
                                type='text'
                                textArea={true}
                                oneLineTextArea={true}
                                onChange={e => this.setState({keywords: e})}
                                value={this.state.keywords}
                                updateErrorsList={this.updateErrorsList}
                                errorMessage="You can enter up to 20 keywords separated by commas."
                                fieldsCheckActive={this.state.fieldsCheckActive}
                                required={!this.props.reservedTrigger}
                            />
                            <p className='input-explanation'>Enter up to 20 keywords separated by commas.</p>
                        </div>
                    }
                    {/*<div className="new-trigger-bottom-border">*/}
                    {/*    <InputRegular*/}
                    {/*        id="2"*/}
                    {/*        label1="Keywords"*/}
                    {/*        label2=""*/}
                    {/*        placeholder="Enter keywords"*/}
                    {/*        type='text'*/}
                    {/*        textArea={true}*/}
                    {/*        oneLineTextArea={true}*/}
                    {/*        onChange={e => this.setState({keywords: e})}*/}
                    {/*        value={this.state.keywords}*/}
                    {/*        updateErrorsList={this.updateErrorsList}*/}
                    {/*        errorMessage="You can enter up to 20 keywords separated by commas."*/}
                    {/*        fieldsCheckActive={this.state.fieldsCheckActive}*/}
                    {/*        required={!this.props.reservedTrigger}*/}
                    {/*    />*/}
                    {/*    <p className='input-explanation'>Enter up to 20 keywords separated by commas.</p>*/}
                    {/*</div>*/}
                    {
                        this.state.actions && this.state.actions.length ?
                            this.state.actions.map((action, index) => {
                                return <div className="new-trigger-bottom-border">
                                    <div className="space-between margin-bottom-10 margin-top-20">
                                        <span><strong>Action #{index + 1}</strong></span>
                                        {((this.state.actions.length > 1) && !this.props.reservedTrigger) ||
                                        (((this.props.name === 'Start') || (this.props.name === 'Stop')) && (index > 1)) ||
                                        ((this.props.name === 'Help') && (index > 0)) ?
                                            <a onClick={() => this.handleRemoveAction(index)}>Remove action</a>
                                            :
                                            ''
                                        }
                                    </div>
                                    {
                                        (
                                            ((this.props.name === 'Stop') || (this.props.name === 'Start')) && (index < 2)
                                        )
                                        ||
                                        (
                                            (this.props.name === 'Help') && (index === 0)
                                        ) ?
                                            <div className="tabs-navigation">
                                                <div
                                                    className={(action.type === 'sms') || (action.type === 'sms_primary') || (action.type === 'auto_reply') ?
                                                        'navigation-tab active' : 'navigation-tab disabled opacity-05'}
                                                >
                                                    Reply with SMS
                                                </div>
                                                <div
                                                    className={action.type === 'tags' ? 'navigation-tab active' : 'navigation-tab disabled opacity-05'}
                                                >
                                                    Assign Tag
                                                </div>
                                                <div
                                                    className={action.type === 'remove_tags' ? 'navigation-tab active' : 'navigation-tab disabled opacity-05'}
                                                >
                                                    Remove Tag
                                                </div>
                                                <div
                                                    className={action.type === 'webhook' ? 'navigation-tab active' : 'navigation-tab disabled opacity-05'}
                                                >
                                                    Webhook URL
                                                </div>
                                                {this.props.name === 'Help' ? '' :
                                                    <div
                                                        className={action.type === 'subscription' ? 'navigation-tab active' : 'navigation-tab disabled opacity-05'}
                                                    >
                                                        Event
                                                    </div>
                                                }
                                            </div>
                                            :
                                            <div className="tabs-navigation">
                                                <div
                                                    className={(action.type === 'sms') || (action.type === 'sms_primary') || (action.type === 'auto_reply') ?
                                                        'navigation-tab active' : 'navigation-tab disabled'}
                                                    onClick={() => this.handleChangeAction('sms', index)}
                                                >
                                                    Reply with SMS
                                                </div>
                                                <div
                                                    className={action.type === 'tags' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                    onClick={() => this.handleChangeAction('tags', index)}
                                                >
                                                    Assign Tag
                                                </div>
                                                <div
                                                    className={action.type === 'remove_tags' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                    onClick={() => this.handleChangeAction('remove_tags', index)}
                                                >
                                                    Remove Tag
                                                </div>
                                                <div
                                                    className={action.type === 'webhook' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                    onClick={() => this.handleChangeAction('webhook', index)}
                                                >
                                                    Webhook URL
                                                </div>
                                                {this.props.name === 'Help' ? '' :
                                                    <div
                                                        className={action.type === 'subscription' ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                        onClick={() => this.handleChangeAction('subscription', index)}
                                                    >
                                                        Event
                                                    </div>
                                                }
                                            </div>
                                    }
                                    {
                                        (action.type === 'sms') || (action.type === 'sms_primary') || (action.type === 'auto_reply') ?
                                            <div className="new-trigger-action-container">
                                                <InputRegular
                                                    className='exceeded'
                                                    // disabled={
                                                    //     (
                                                    //         ((this.props.title === 'Unsubscribe') || (this.props.title === 'Subscribe')) && ( index < 2 )
                                                    //     )
                                                    //     ||
                                                    //     (
                                                    //         (this.props.title === 'Help') && (index === 0)
                                                    //     ) ? true : false}
                                                    id={index + 3}
                                                    label1="Response Message"
                                                    label2=""
                                                    placeholder="Enter message here"
                                                    type='text'
                                                    textArea={true}
                                                    onChange={value => this.handleActionUpdate('sms', index, value)}
                                                    value={this.state.actions[index].value}
                                                    updateErrorsList={this.updateErrorsList}
                                                    errorMessage="Message can't be empty"
                                                    fieldsCheckActive={this.state.fieldsCheckActive}
                                                    required={true}
                                                />

                                                {
                                                    this.state.actions[index].characterCount ?
                                                        <p className='character-count'>
                                                            Characters:<span>{(this.state.actions[index].characterCount + '/' +
                                                            this.state.actions[index].charsPerMessage * this.state.actions[index].messagesCount)} </span>
                                                            Messages: <span>{this.state.actions[index].messagesCount}</span>
                                                        </p>
                                                        :
                                                        ''
                                                }
                                                <p className='character-count'></p>
                                                {/*<p className='input-label'>Response Message</p>*/}
                                                {/*<TextArea*/}
                                                {/*    className={ 'input' }*/}
                                                {/*    value={ this.state.message }*/}
                                                {/*    placeholder={ 'Enter message here' }*/}
                                                {/*    onChange={ ({ currentTarget: input }) => this.handleActionUpdate('Reply with SMS', index, input.value)}*/}
                                                {/*/>*/}
                                                {this.state.exceedingError ?
                                                    <p className='text-red exceeding-error'>
                                                        One auto-response message can't contain more than 320
                                                        characters. For additional content add an additional Reply with
                                                        SMS action.
                                                    </p>
                                                    : ''
                                                }
                                                <p className='input-explanation'>{this.props.name === 'Default Response' ?
                                                    'When someone sends you a message you can reply with this default response automatically.'
                                                    :
                                                    'When someone sends you the message containing trigger word, this SMS ' +
                                                    'message will be sent as a confirmation to the user automatically.'}</p>
                                            </div>
                                            :
                                            (action.type === 'tags') || (action.type === 'remove_tags') ?
                                                <div className={
                                                    this.state.fieldsCheckActive && !this.state.actions[index].value.length ?
                                                        "new-trigger-action-container multi-select-error-container" :
                                                        "new-trigger-action-container multi-select-container"}
                                                >
                                                    <p className='input-label'>
                                                        {
                                                            action.type === 'tags' ? 'Assign these tags to the Sender' : 'Remove these tags from the Sender'
                                                        }
                                                    </p>

                                                    <TagsMultiselector
                                                        tags={this.props.tags}
                                                        selectedTags={this.state.actions[index].selectedTags}
                                                        squareType={true}
                                                        width={'100%'}
                                                        updateTags={tags => this.updateTags(tags, index)}
                                                        // updateTagsIds={ this.updateTagsIds }
                                                        handleCreateTag={this.props.handleCreateTag}
                                                        handleGetTags={this.props.handleGetTags}
                                                        dontHandleGetTags={true}
                                                    />

                                                    {/*<MultiSelect*/}
                                                    {/*    items={this.props.tags}*/}
                                                    {/*    itemRenderer={(item, object) => this.multiMenuItem(item, this.state.actions[index].selectedTags, object)}*/}
                                                    {/*    tagInputProps={{*/}
                                                    {/*        placeholder: 'Filter by tag',*/}
                                                    {/*        onRemove: (tag) => this.handleTagRemove(tag, index)*/}
                                                    {/*    }}*/}
                                                    {/*    resetOnSelect={true}*/}
                                                    {/*    className="tag-multiselect countries-multiselect"*/}
                                                    {/*    onItemSelect={(tag) => this.tagSelect(tag, index)}*/}
                                                    {/*    tagRenderer={this.tagRender}*/}
                                                    {/*    itemListPredicate={this.filterTags}*/}
                                                    {/*    selectedItems={this.state.actions[index].selectedTags || []}*/}
                                                    {/*    fill={true}*/}
                                                    {/*    noResults={<MenuItem disabled={true} text="No results."/>}*/}

                                                    {/*/>*/}
                                                    <div className="margin-bottom-20"/>
                                                </div>
                                                :
                                                action.type === 'webhook' ?
                                                    <div className="new-trigger-action-container">
                                                        {/*<p className='input-label'>Webhook URL</p>*/}
                                                        <InputRegular
                                                            id={index + 3}
                                                            label1="Webhook URL"
                                                            label2=""
                                                            placeholder="Enter URL"
                                                            type='url'
                                                            onChange={e => this.handleActionUpdate('webhook', index, e)}
                                                            value={this.state.actions[index].value}
                                                            updateErrorsList={this.updateErrorsList}
                                                            errorMessage="Must be a valid url"
                                                            fieldsCheckActive={this.state.fieldsCheckActive}
                                                            required={true}
                                                        />
                                                    </div>
                                                    :
                                                    <div>
                                                        <p className='input-label'>Subscribe or Unsubscribe this
                                                            contact</p>
                                                        {
                                                            this.props.name === 'Start' || this.props.name === 'Stop' ?
                                                                <div className="tabs-navigation">
                                                                    <div
                                                                        className={parseInt(action.value) === 1 ? 'navigation-tab active opacity-05' : 'navigation-tab disabled opacity-05'}
                                                                    >
                                                                        Subscribe contact
                                                                    </div>
                                                                    <div
                                                                        className={parseInt(action.value) === 0 ? 'navigation-tab active opacity-05' : 'navigation-tab disabled opacity-05'}
                                                                    >
                                                                        Unsubscribe contact
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="tabs-navigation">
                                                                    <div
                                                                        className={parseInt(action.value) === 1 ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                                        onClick={() => this.handleActionUpdate('subscription', index, 1)}
                                                                    >
                                                                        Subscribe
                                                                    </div>
                                                                    <div
                                                                        className={parseInt(action.value) === 0 ? 'navigation-tab active' : 'navigation-tab disabled'}
                                                                        onClick={() => this.handleActionUpdate('subscription', index, 0)}
                                                                    >
                                                                        Unsubscribe
                                                                    </div>
                                                                </div>
                                                        }
                                                    </div>
                                    }
                                </div>
                            })
                            :
                            ''
                    }
                    <div className="flex-direction-row space-between">
                        <button
                            // disabled={this.state.actions && (this.state.actions.length > 2)}
                            onClick={this.handleAddAction}
                            className='btn-white'
                        >
                            Add Action
                        </button>
                        <div className="flex-direction-row flex-end">
                            <button onClick={this.handleEdit}
                                    className='btn-white margin-right-10'>Cancel
                            </button>

                            {
                                this.state.spinnerActive ?
                                    <button onClick={() => {
                                        // this.handlePatchTrigger();
                                        // this.props.handleSave({keywords: this.state.keywords.split(',').map(item => item.trim()).filter(x=>x), message: this.state.message});
                                        // this.handleEdit();
                                    }} className='btn-action btn-spinner'>Save <i
                                        className='fa fa-spin fa-spinner'></i></button>
                                    :
                                    <button onClick={() => {
                                        this.handlePatchTrigger();
                                    }} className='btn-action'>Save</button>
                            }


                        </div>
                    </div>
                </div>
                :
                <div className="single-trigger-container">
                    {/*<h3>{this.props.title} <InfoCircle*/}
                    {/*    icon={'question-grey'}*/}
                    {/*    rows={2}*/}
                    {/*    infoCircleContent={*/}
                    {/*        <p>{this.props.infoDescription}</p>*/}
                    {/*    }*/}
                    {/*/></h3>*/}
                    <div className="single-trigger-title">
                        <h3>{this.props.name === 'Start' ? 'Subscribe' : this.props.name === 'Stop' ? 'Unsubscribe' : this.props.name}</h3>
                        {this.props.infoDescription ?

                            <InfoCircle
                                icon='question'
                                infoCircleContent={
                                    <p className='info-circle-content'>
                                        {this.props.infoDescription}
                                    </p>
                                }
                            /> : ''
                        }
                    </div>
                    {this.props.name === 'Stop' ?
                        <p className="edit-text" onClick={this.handleEdit}
                           data-intercom-target="Edit">Edit</p> :
                        <p className="edit-text" onClick={this.handleEdit}>Edit</p>
                    }
                    <div className="triggers-container">
                        {this.state.defaultResponseActive ?
                            <div className="margin-top-20 flex-direction-row align-items-center">
                                <div className='label-container'><span
                                    className="keywords-label">Status: </span></div>

                                <span
                                    className={this.state.defaultResponseActive === 'response-active' ? 'tag-green' : 'tag-red'}
                                    key={1}>
                                    {this.state.defaultResponseActive === 'response-active' ? 'active' : 'disabled'}
                                </span>
                            </div>
                            :
                            <div className="margin-top-20 flex-direction-row align-items-center">
                                <div className='label-container'><span
                                    className="keywords-label">Keywords: </span>
                                </div>
                                {this.props.reservedKeywords && this.props.reservedKeywords.length ? this.props.reservedKeywords.map((trigger, key) =>
                                    <span className='tag' key={key}>{trigger}</span>) : ''}
                                {this.props.keywords && this.props.keywords.length ? this.props.keywords.map((trigger, key) =>
                                    <span className='tag' key={key}>{trigger}</span>) : ''}
                            </div>
                        }

                        <p className="actions-title"><strong>ACTIONS</strong></p>
                        {this.props.actions && this.props.actions.length ? this.props.actions.map(action => {
                            return (action.type === 'sms') || (action.type === 'sms_primary') || (action.type === 'auto_reply') ?
                                <div
                                    className="margin-top-20 margin-bottom-20 flex-direction-row align-items-center">
                                    <div className='label-container'>
                                        <span className="message-label">Send SMS: </span>
                                    </div>
                                    <span>{action.value}</span>
                                </div> :
                                (action.type === 'tags') || (action.type === 'remove_tags') ?
                                    <div
                                        className="margin-top-20 margin-bottom-20 flex-direction-row align-items-center">
                                        <div className='label-container'>
                                            <span
                                                className="keywords-label">{(action.type === 'tags') ? 'Assign Tag:' : 'Remove Tag:'}</span>
                                        </div>
                                        {action.selectedTags && action.selectedTags.length ?
                                            action.selectedTags.map(tag => <span
                                                className='tag'>{tag.tag}</span>)
                                            :
                                            ''}
                                    </div>
                                    :
                                    action.type === 'webhook' ?
                                        <div
                                            className="margin-top-20 margin-bottom-20 flex-direction-row align-items-center">
                                            <div className='label-container'><span
                                                className="message-label">Notify
                                                Webhook: </span>
                                            </div>
                                            {action.value}
                                        </div>
                                        :
                                        <div
                                            className="margin-top-20 margin-bottom-20 flex-direction-row align-items-center">
                                            <div className='label-container'><span
                                                className="message-label">Event: </span>
                                            </div>
                                            {parseInt(action.value) === 1 ? 'Subscribe' : 'Unsubscribe'}
                                        </div>
                        }) : ''}

                    </div>
                </div>
        )

    }

}


export default SingleTrigger;